
import Vue from "vue";

export default Vue.extend({
  name: "Header",
  data() {
    return {
      scrolled: false,
      menuOpen: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 20;
    },
    close() {
      this.menuOpen = false;
    }
  }
});
